import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M17 4H3v12h14V4zM3 2a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2H3z" /><path d="M10.5 9L3 16h14V7.5L13.5 12l-3-3zM8.5 7.5a2 2 0 11-4 0 2 2 0 014 0z" /></svg>;